import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ListAuditHistoryPageNew from "../../components/Audit History/ListAuditHistoryPageNew";

const AuditHistoryList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Audit History" />

        <ListAuditHistoryPageNew/>
      </MasterLayout>
    </>
  );
};

export default AuditHistoryList;